import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography
} from '@material-ui/core';

const ModelsToolBar = (props) => {
  const navigate = useNavigate();

  const goToAdd = () => {
    navigate('/app/models/add');
  };

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button color="primary" variant="contained" onClick={goToAdd}>
          ADD MODEL
        </Button>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card>
          <CardContent>
            <Box sx={{ maxWidth: 500 }}>
              <Typography>Models</Typography>
              {/* <TextField
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon fontSize="small" color="action">
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  )
                }}
                placeholder="Search service"
                variant="outlined"
              /> */}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default ModelsToolBar;
